function Reflection() {
  return (
    <section className="w-full mb-16 font-DM" id="Reflection">
      <h1 className="font-DM text-pinkie uppercase mb-6">Reflection</h1>

      <p className="font-DM">
        Through this project, I learned the iterative process of constantly
        diverging and converging within a project to explore different
        directions that would ultimately lead us to our final destination—the
        finished product. In our limited time frame, I gained experience in
        working within a deadline, striking a balance between our ambitions and
        the realities of the project, and learning to discard ideas and elements
        that weren't essential. Our explorations also emphasized the importance
        of using references and inspirations from experts in the field, steering
        away from designing solely in our heads. Given additional time, I aim to
        refine certain aspects, such as intricately choreographing animations
        across pages and enhancing overall harmony through meticulous attention
        to detail.
      </p>
    </section>
  );
}

export default Reflection;
